module.exports = __webpack_public_path__ + "c29935262d9d61597d230058dc3bc825.svg";